import { render, staticRenderFns } from "./sendList.vue?vue&type=template&id=39a7df7c&scoped=true"
import script from "./sendList.vue?vue&type=script&lang=js"
export * from "./sendList.vue?vue&type=script&lang=js"
import style0 from "./sendList.vue?vue&type=style&index=0&id=39a7df7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a7df7c",
  null
  
)

export default component.exports